import { jsx as _jsx } from "react/jsx-runtime";
import { FormControlLabel } from '@mui/material';
import React, { useEffect } from 'react';
import { StyledSwitch } from './styles';
export const CustomSwitch = ({ isChecked, labels, onChange, sectionName }) => {
    const [switchLabel, setSwitchLabel] = React.useState('');
    useEffect(() => {
        setSwitchLabel(isChecked ? labels.on : labels.off);
    }, [isChecked, labels.on, labels.off]);
    const aria = { slotProps: { input: { 'aria-label': switchLabel } } };
    const currentPillarName = window.location.href.split('/')[3] || ' ';
    const gaToggleAttributes = {
        'data-navigation-name': currentPillarName == 'goalsetting'
            ? 'Goals'
            : currentPillarName[0]?.toUpperCase() + currentPillarName.slice(1),
        'data-section-name': sectionName,
        'data-section-id': sectionName,
        'data-insight-id': 'Not applicable',
        'data-click-text': switchLabel,
        'data-type': 'Toggle',
    };
    return (_jsx(FormControlLabel, { control: _jsx(StyledSwitch, { ...aria, checked: isChecked }), label: switchLabel, onChange: (e, checked) => {
            onChange(e, checked);
        }, ...gaToggleAttributes }));
};
